import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppComponent } from '../app.component';
import {menuItemsBreadcrumb} from "../const/menu-items-breadcrumb";

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./breadcrumb.component.less']
})
export class BreadcrumbComponent implements OnInit {
	breadcrumbItems: any[] = [];

	constructor(
		public app: AppComponent,
	) { }

	ngOnInit(): void {
		this.breadcrumbItems = menuItemsBreadcrumb;
		console.log("this.breadcrumbItems ==> ", this.breadcrumbItems);
	}

	getCurrentStep(_step: any) {
		return (this.app.router.url.indexOf(_step.page) != -1) ? 'bc-active' : "";
	}

}
